/**
 * 全部资源
 * created by yxy
 *
 */
import React, {Component} from 'react';
import {
    HEADER_HEIGHT,
} from "../../constants";
import PropTypes from 'prop-types';
import {Card, Button, Radio, Popover, Input, Modal, Icon, message, Divider} from 'antd';
import * as Actions from "../../actions/allResources";
import ResourcePool from "../../view/components/resourcePool/ResourcePool";
import RightClickMenu from "../components/rightClickMenu/RightClickMenu";
import {Scrollbars} from "react-custom-scrollbars";

import label from './img/label.png';
import cover from './img/cover.png';
import audio from './img/audio.png'
import video from './img/video.png'
import file from './img/file.png'
import picture from './img/picture.png'
import filecopy from './img/filecopy.png'
import $ from 'jquery'
import {storageDirectorySize,removeFromDirecotry} from "../../actions/allResources"
import {
    search, getAllParent, getByPath, getPictureInfosByPath, addLabel, addRelatedDeptIds, moveToRecycle,
    storageDirectoryRename, moveByDirectoryIdsAndFileIds, storageFileRename
} from "../../actions/storageList";
import {formateData, getBatchDownloadPath, headers} from "../../actions";
import SetUp from '../../view/components/setUp/SetUp'
import {StorageDirectory} from "../../components/storageList";
import HoldAll from "../components/holdAll/HoldAll";
import {applicationName, formatDate} from "../../utils";
import BaseComponent from "../../base/BaseComponent";

const {Search} = Input;
const {confirm} = Modal;
let picFiles = [];
let array = [];
export default class AllResources extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {

        super(props);
        this.state = {
            value: 1,
            type: 'small',
            current: 0,
            status:'0',
            resourceId: '',
            dataSource: [],
            picList: [],
            fileList: [],
            imgList: [],
            holdAll: false,
            attribute: false,
            warehousing: false,
            showProcess: true,
            fileListArray: [],
            resourceType: '',
            openAll: false,
            AllData:[],
            start:1,
            pageSize:40,
            checkedId: {
                directoryIds: [],
                fileIds: [],
                allIds: []
            },
            right:false,
            downloadFile:[],
            history:require("history").createHashHistory(),
            listArray: [
                {
                    id: '1',
                    title: '追加标签',
                    content: '可以给当前文件或文件夹下的子文件追加标签。',
                    img: label
                },
                {
                    id: '3',
                    title: '图片搜索引擎',
                    content: '通过人脸识别、标签、名称等多种搜索功能在时光轴、瀑布流、列表展示的方式下进行搜索。',
                    img: picture
                }, {
                    id: '4',
                    title: '视频搜索引擎',
                    content: '通过标签、名称等多种搜索功能在时光轴、瀑布流、列表展示的方式下进行搜索。',
                    img: video
                }, {
                    id: '5',
                    title: '音频搜索引擎',
                    content: '通过标签、名称等多种搜索功能在时光轴、瀑布流、列表展示的方式下进行搜索。',
                    img: audio
                },
                {
                    id: '6',
                    title: '文件搜索引擎',
                    content: '通过标签、名称等多种搜索功能在时光轴、瀑布流、列表展示的方式下进行搜索。',
                    img: file
                },

            ],
            storageDirectoryVisible: false,
            targetKeys: [],
            blank:false,
            array: [
                {
                    title: '学校活动',
                    singleOpen: false,
                    list: [
                        {
                            id: '1',
                            checked: false,
                            type: 'img',
                            img: '/storage/DFCBEA29DA0EBDA07E62AAD26C094170/small/quality'
                        },
                        {
                            id: '2',
                            checked: false,
                            type: 'video',
                            img: '/storage/DFCBEA29DA0EBDA07E62AAD26C094170/small/quality'
                        }, {
                            id: '3',
                            checked: false,
                            type: 'audio',
                            img: '/storage/DFCBEA29DA0EBDA07E62AAD26C094170/small/quality'
                        },
                    ]
                },
                {
                    title: '1212',
                    singleOpen: false,
                    list: [
                        {
                            id: '4',
                            checked: false,
                            type: 'img',
                            img: '/storage/DFCBEA29DA0EBDA07E62AAD26C094170/small/quality'
                        },
                        {
                            id: '5',
                            checked: false,
                            type: 'video',
                            img: '/storage/DFCBEA29DA0EBDA07E62AAD26C094170/small/quality'
                        },
                        {
                            id: '6',
                            checked: false,
                            type: 'audio',
                            img: '/storage/DFCBEA29DA0EBDA07E62AAD26C094170/small/quality'
                        },
                        {
                            id: '7',
                            checked: false,
                            type: 'audio',
                            img: '/storage/DFCBEA29DA0EBDA07E62AAD26C094170/small/quality'
                        },
                        {
                            id: '8',
                            checked: false,
                            type: 'audio',
                            img: '/storage/DFCBEA29DA0EBDA07E62AAD26C094170/small/quality'
                        },
                    ],
                }
            ],
            rename: false,
            name: '',
            backList: [],//入库资源菜单
            currentId: '',
            attributeFiles: {
                createTime: '',
                size: '',
                name: ''
            },
            department: [],
            user: [],
            folder:true,
            filecopy: false,
            rightClickMenu: [
                {
                    title: '重命名', onClick: (e) => {
                        if (this.state.right === true) {
                            this.rename()
                        }
                    }, color: 'grey'
                },
                {
                    title: '移除', onClick: () => {
                        if (this.state.right === true) {
                            this.remove()
                        }
                    }, color: 'grey'
                },
                {
                    title: '彻底删除', onClick: () => {
                        if (this.state.right === true) {
                            this.gotoRecycle()
                        }
                    }, color: 'grey'
                },
                {
                    title: '刷新', onClick: () => {
                        this.getList()
                    }, color: 'black'
                },
                {
                    title: '剪切', onClick: () => {
                        if (this.state.right === true) {
                            this.copyFile()
                        }
                    }, color: 'grey'
                },
                {
                    title: '粘贴', onClick: () => {
                        if (this.state.filecopy === true) {
                            this.paste()
                        }

                    }, color: 'grey'
                },
                {
                    title: '属性', onClick: () => {
                        if (this.state.right === true) {
                            this.attribute()
                        }
                    }, color: 'grey'
                },
            ]
        }
    }

    componentWillMount() {

    }

    componentDidMount() {
        let resourceId = this.props.match.params.resourceId;
        this.state.currentId = this.props.match.params.resourceId;
        let resourceType = this.props.resourceType;
        this.setState({resourceId: resourceId, resourceType: resourceType}, () => {
            this.getList();
            this.backList()
        });

    }

    componentWillReceiveProps(nextProps, nextContext) {

        if (this.props.currentId !== nextProps.currentId) {
            this.updatePosition(nextProps.currentId);
        }
    }

    updatePosition(id) {
        let index = window.layer.load();
        let that = this;
        getAllParent(id, (data) => {
            window.layer.close(index);
            this.props.callBackList && this.props.callBackList(data);
            that.setState({
                dataSource: data.reverse()
            })
        })
    }

    render() {
        const buttonWidth = 70;
        let height = window.innerHeight - HEADER_HEIGHT;//上部分70//
        let margin = 15;
        let otherHeight = 190 + margin * 2;
        let title;
        switch (this.state.resourceType) {
            case 0:
                title = '全部资源';
                break;
            case 1:
                title = '全部图片';
                break;
            case 2:
                title = '全部音频';
                break;
            case 3:
                title = '全部视频';
                break;
            case 4:
                title = '其他文件';
                break;
        }
        const content = (
            <div>
                <Radio.Group onChange={this.onChangeType} value={this.state.type}>
                    <p><Radio value={'small'}>小图标</Radio></p>
                    <p><Radio value={'middle'}>中图标</Radio></p>
                    <p><Radio value={'big'}>大图标</Radio></p>
                    <p><Radio value={'list'}>列表</Radio></p>
                </Radio.Group>
                <div style={{paddingTop: '10px',borderTop:'1px solid #f2f2f2'}}>
                    <Radio.Group onChange={(e)=>this.onChangeStatus(e)} value={this.state.status}>
                        <p><Radio value={"1"}>名称(升序)</Radio></p>
                        <p><Radio value={"2"}>名称(降序)</Radio></p>
                        <p><Radio value={"3"}>日期(升序)</Radio></p>
                        <p><Radio value={"4"}>日期(降序)</Radio></p>
                        <p><Radio value={"5"}>类型(升序)</Radio></p>
                        <p><Radio value={"6"}>类型(降序)</Radio></p>
                        <p><Radio value={"7"}>大小(升序)</Radio></p>
                        <p><Radio value={"8"}>大小(降序)</Radio></p>
                    </Radio.Group>
                </div>
            </div>

        );
        return (
            <div>
                <Card title={title} style={{margin: 15,}}>
                    <style>{`.ant-card-head-title{font-size:14px}`}</style>
                    <div style={{position: 'relative'}}>
                        <Button style={{marginRight: 15}} icon={"cloud-upload"} onClick={(e) => {
                            this.showOnlyFileUploadDialog()
                        }}>上传文件</Button>
                        <Button style={{marginRight: 15}} icon={"download"}
                                onClick={() => this.gotoBatchDownload()}>下载</Button>
                        <Button style={{marginRight: 15}} icon={"folder-add"}
                                onClick={(e) => this.createStorageDirectory(e)}>新建文件夹</Button>
                        <Button style={{marginRight: 15}} icon={"fork"} onClick={this.showModalShare}>分享</Button>
                        <Button style={{marginRight: 15}} icon={"tool"} onClick={this.showModalHoldAll}>工具箱</Button>
                        <Button style={{marginRight: 15, display: 'none'}} icon={"setting"}
                                onClick={this.showModalSetting}>设置分类</Button>
                        <Radio.Group onChange={this.onChangeRadio} value={this.state.value}>
                            <Radio value={1}>单选</Radio>
                            <Radio value={2}>多选</Radio>
                            <Radio value={3}>全选</Radio>
                            <Radio value={4}>反选</Radio>
                        </Radio.Group>
                        <div style={{position: 'absolute', right: '0', top: '0'}}>
                            <Search
                                placeholder="请输入文件名"
                                onSearch={this.search}
                                style={{width: 200}}
                            />
                        </div>
                        <StorageDirectory
                            visible={this.state.storageDirectoryVisible}
                            handleOk={(id) => this.handleOk(id)}
                            confirmLoading={this.state.storageDirectoryLoading}
                            handleCancel={() => this.handleCancel()}
                        />
                    </div>
                    <div style={{display: 'flex', justifyContent: 'space-between', lineHeight: '50px'}}>
                        {/*渲染返回上一级*/}
                        {this.renderBackNav()}
                        <div>
                            <span>共：</span>
                            <span>{this.state.fileListArray ? this.state.fileListArray.length : 0}个文件夹,</span>
                            <span>{this.state.imgList ? this.state.imgList.length : 0}个文件</span>
                            <Popover placement="leftTop" content={content} trigger="click">
                                <Button icon={"appstore"} style={{marginLeft: 15}}></Button>
                            </Popover>
                        </div>

                    </div>
                    <div id="rightClick" style={{height: height - otherHeight}} onContextMenu={(e) => {
                        this.contentRightClick(e)
                    }}>
                        <Scrollbars  onScroll={this.onScroll.bind(this)}
                                     autoHide
                                     autoHideTimeout={1}
                                     autoHideDuration={1}
                                     style={{height: height - otherHeight, position: 'relative'}}
                                     ref={(scrollRef) => {
                                         this.scrollRef = scrollRef
                                     }}>
                            {
                                this.state.dataSource.map((item, index) => {
                                    let path = item.path;
                                    if (item.fileType === "video") {
                                        path = item.path.replace(/(\/storage\/[a-zA-Z0-9]{32}).*/, "$1") + "/thumbnails/1";
                                    } else if (item.fileType === "other") {
                                        path = "images/other.png"
                                    }
                                    return (
                                        <ResourcePool key={index} createTime={formatDate(item.createTime.time)}
                                                      type={this.state.type} title={item.name} img={path}
                                                      checked={item.checked} fileType={item.fileType}
                                                      singleClick={() => this.singleClick(index, item)}
                                                      currentOnContextMenu={() => {
                                                          item.checked = false;
                                                          if (!item.checked) {
                                                              this.singleClick(index, item);
                                                              this.state.blank = true
                                                          }
                                                      }

                                                      }
                                                      doubleClick={() => {
                                                          array = [];
                                                          this.pushBacklist(item);
                                                          if (item.fileType === 'file') {
                                                              this.setState({resourceId: item._id});
                                                          }
                                                          this.handleDoubleClick(item)
                                                      }}


                                        />

                                    )
                                })
                            }
                        </Scrollbars>
                        <RightClickMenu menu={this.state.rightClickMenu}
                                        ref={RightClickMenu => this.RightClickMenu = RightClickMenu}/>
                    </div>
                </Card>
                {/*文件属性*/}
                {this.fileProperties()}
                {/*文具箱*/}
                {this.toolCabinet()}
                {/*重命名*/}
                {this.fileRename()}
                <SetUp ref={SetUp => {
                    this.SetUp = SetUp
                }} resourceType={this.props.resourceType} resourceId={this.state.resourceId} callbackData={() => {
                    this.getList()
                }}></SetUp>
                <HoldAll
                    ref={(HoldAll) => this.showModal = HoldAll} Btn={true}
                    onSaveCallback={(depr, user) => {
                        this.onSaveCallback(depr, user)
                    }}
                />
            </div>
        )
    }
    onChangeStatus(e){
        this.state.dataSource = [];
        this.state.AllData = [];
        this.state.start = 1;
        let sortType,sortCondition;
        if(e.target.value === '1' ||e.target.value ==='3' ||e.target.value ==='5' ||e.target.value ==='7' ){
            sortType = 1
        }else{
            sortType = -1
        }
        if(e.target.value === '1' ||e.target.value === '2' ){
            sortCondition='name'
        }else if(e.target.value === '3' ||e.target.value === '4' ){
            sortCondition='createTime'
        }else if(e.target.value === '5' ||e.target.value === '6' ){
            sortCondition='type'
        }else{
            sortCondition='size'
        }

        Actions.getresourcesList(this.state.resourceId, (data) => {
            this.pubicList(data,sortType,sortCondition)
        },sortType,sortCondition,)
        this.setState({status: e.target.value,});
    }
    backList(){
        if(this.state.resourceType === 0){
            this.state.backList = [{name: '全部文件', _id: 0}]
        }else if(this.state.resourceType === 1){
            this.state.backList = [{name: '全部图片', _id: 0}]
        }else if(this.state.resourceType === 2){
            this.state.backList = [{name: '全部音频', _id: 0}]
        }else if(this.state.resourceType === 3){
            this.state.backList = [{name: '全部视频', _id: 0}]
        }else{
            this.state.backList = [{name: '其他文件', _id: 0}]
        }
        this.setState({})
    }
    pushBacklist = (item) => {

        if (item.fileType && item.fileType === 'file') {
            this.state.backList.push(item);
            this.setState({})
        }
    };

    //渲染重命名的弹框
    fileRename() {
        return (
            <Modal
                title="重命名"
                visible={this.state.rename}
                onOk={this.handleRenameOk}
                centered
                onCancel={() => {
                    this.setState({rename: false})
                }}
            >
                <Input value={this.state.name} onChange={(e) => {
                    this.setState({name: e.target.value})
                }}/>
            </Modal>
        )
    }

    //文具箱
    toolCabinet() {
        return (
            <Modal
                title="工具箱"
                centered
                width='812px'
                visible={this.state.holdAll}
                footer={null}
                onCancel={this.handleCancel}
            >
                <div style={{height: '570px'}}>
                    <Scrollbars>
                        <div style={{
                            display: 'flex',

                            flexWrap: 'wrap',
                            marginBottom: '30px'
                        }}>
                            {
                                this.state.listArray.map((item, index) => {
                                    return (
                                        <div key={index} style={{
                                            display: 'flex',
                                            width: '358px',
                                            height: '122px',
                                            backgroundColor: '#ffffff',
                                            boxShadow: '-1px 2px 20px 0px rgba(0, 0, 0, 0.1)',
                                            margin: '12px',
                                            cursor: 'pointer'
                                        }} onClick={() => {
                                            this.holdAll(item.id)
                                        }}>
                                            <div><img src={item.img} style={{
                                                width: '52px',
                                                height: '48px',
                                                objectFit: 'cover',
                                                margin: '34px 36px 40px 39px'
                                            }}/></div>
                                            <div style={{marginRight: '29px'}}>
                                                <p style={{
                                                    marginTop: '20px',
                                                    fontSize: '16px',
                                                    marginBottom: '12px'
                                                }}>{item.title}</p>
                                                <p style={{fontSize: '12px', color: '#999999'}}>{item.content}</p>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </Scrollbars>
                </div>
            </Modal>
        )
    }
    //文件属性
    fileProperties() {
        return (
            <Modal
                title="文件属性"
                centered
                visible={this.state.attribute}
                bodyStyle={{background: '#f2f2f2'}}
                wrapClassName={'attributeModal'}
                onOk={this.sureAttribute}
                onCancel={this.handleCancel}
            >
                <style>{`.attributeModal .ant-modal-body{padding:20px 10px}`}</style>
                <div style={{background: 'white', padding: '20px'}}>
                    <div style={{fontWeight: '600'}}>常规</div>
                    <div style={{lineHeight: '60px', display: 'flex'}}>
                        <div style={{width: '20%'}}>

                            {<img style={{width: '50px', height: '50px', objectFit: 'cover'}}
                                  src={this.state.attributeFiles.name === '文件夹' ? filecopy : this.state.attributeFiles.src}/>}
                        </div>
                        <div><Input style={{width: 300}} value={this.state.name} onChange={(e) => {
                            this.setState({name: e.target.value})
                        }}/></div>
                    </div>
                    <Divider style={{margin: 0}}/>
                    <div style={{display: 'flex', lineHeight: '40px'}}>
                        <div style={{width: '20%'}}>类型:</div>
                        <div> {this.state.attributeFiles && this.state.attributeFiles.name}</div>

                    </div>
                    <div style={{display: 'flex', lineHeight: '40px'}}>
                        <div style={{width: '20%'}}>位置:</div>
                        <div>
                            {
                                this.state.backList.map((item, index) => {
                                    if (index === this.state.backList.length - 1) {
                                        return (
                                            <span key={index} className={'ant-tabs-tab-active'}>{item.name}</span>)
                                    } else {
                                        return (<span key={index} onClick={() => {
                                                this.itemNavClick(item, index)
                                            }}>{item.name}{'/'}</span>
                                        )
                                    }
                                })
                            }
                        </div>
                    </div>
                    <div style={{display: 'flex', lineHeight: '40px'}}>
                        <div style={{width: '20%'}}>大小:</div>
                        <div>{this.state.attributeFiles && this.state.attributeFiles.size}</div>
                    </div>
                    {
                        this.state.attributeFiles && this.state.attributeFiles.name === '文件夹' ?
                            <div style={{display: 'flex', lineHeight: '40px', marginTop: 20}}>
                                <div style={{width: '20%'}}>包含:</div>
                                <div>{this.state.attributeFiles && this.state.attributeFiles.count}个文件,{this.state.attributeFiles && this.state.attributeFiles.directorySize}个文件夹</div>
                            </div> : null
                    }

                    <Divider style={{margin: '10px 0 0 0'}}/>
                    <div style={{display: 'flex', lineHeight: '60px'}}>
                        <div style={{width: '20%'}}>创建时间:</div>
                        <div>{formatDate(this.state.attributeFiles && this.state.attributeFiles.createTime)}</div>
                    </div>
                </div>

            </Modal>
        )
    }

    //渲染面包屑
    renderBackNav() {
        return (
            <div> {this.state.backList.length > 1 ?
                <span onClick={() => this.goBackNav()} className={'ant-tabs-tab-active'}
                      style={{cursor: 'pointer'}}>返回上一级&nbsp;</span> : null}
                <span>&nbsp;当前位置:</span>
                {
                    this.state.backList.map((item, index) => {
                        if (index === this.state.backList.length - 1) {
                            return (<span key={index} className={'ant-tabs-tab-active'}>{item.name}</span>)
                        } else {
                            return (<span key={index} className={'ant-tabs-tab-active'} style={{cursor: 'pointer'}}
                                          onClick={() => {
                                              this.itemNavClick(item, index)
                                          }}>{item.name}{'/'}</span>
                            )
                        }
                    })
                }
            </div>
        )
    }

    // 分享的弹框
    showModalShare = () => {
        this.publish();
        if (this.state.checkedId.allIds.length) {
            if (this.state.checkedId.directoryIds.length) {
                message.info("文件夹不可以分享!");
            } else {
                this.showModal.show(true)
            }
        } else {
            message.info("请至少选择一个文件");
        }

    };
    //分享的事件
    onSaveCallback = (department, user) => {
        let depr = [];
        department.forEach((item, index) => {
            depr.push(parseInt(item))
        });
        let allIds = this.state.checkedId.allIds;
        let params = {};
        params.ids = allIds;
        params.usr = user;
        params.dsr = depr;
        if (user.length || depr.length) {
            Actions.setShareRight(params, (data) => {

            })
        }

    };

    //复制
    copyFile() {
        this.publish();
        if (this.state.checkedId.allIds.length) {
            this.setState({filecopy: true})
        } else {
            message.info("请至少选择一个文件或文件夹!");
        }
    }

    //粘贴
    paste() {

        let that = this;
        if (this.state.checkedId.allIds.length) {
            let fileIds = that.state.checkedId.fileIds;
            let directoryIds = that.state.checkedId.directoryIds.toString().replace(/(.*),$/, '$1');
            moveByDirectoryIdsAndFileIds(directoryIds, fileIds.join(","), this.state.resourceId, (data) => {
                this.getList()
                this.setState({filecopy: false})
            })

        } else {
            message.info("请至少复制一个文件或文件夹!");

        }

    }

    //返回上一级
    goBackNav() {

        let record = this.state.backList[this.state.backList.length - 2];
        this.state.backList.splice(this.state.backList.length - 1, 1);
        if (record._id === 0) {
            this.state.resourceId = this.state.currentId;
            this.setState({})
        }
        if (record._id) {
            this.state.resourceId = record._id;
            this.handleDoubleClick(record)
        } else {
            this.getList()
        }
    }

    //nav每一项点击
    itemNavClick(item, index) {
        let current = index;
        //  length 比 index 大1
        //
        let deleteNUm = this.state.backList.length - index;
        this.state.backList.splice(index + 1, deleteNUm - 1);
        if (item._id === 0) {
            this.state.resourceId = this.state.currentId;
            this.setState({})
        }
        if (item._id) {
            this.state.resourceId = item._id
            this.setState({})
            this.handleDoubleClick(item)
        } else {
            this.state.backList = [{name: '全部文件', _id: 0}];
            this.getList()
        }
    }

    //属性
    attribute() {
        window.loading.show()
        if (array.length) {
            let obj = array[0];
            this.setState({name: obj.name,});
            if (obj.fileType === 'file') {
                storageDirectorySize(obj._id, (data) => {
                    let newData = {};
                    if (data) {
                        let createTime = array[0].createTime.time;
                        newData = data;
                        newData.createTime = createTime;
                        newData.name = '文件夹'
                    }
                    if (data.size.startsWith('.')) {
                        data.size = '0' + data.size
                    }
                    this.setState({attributeFiles: newData, attribute: true});
                    window.loading.hide();
                })
            } else {
                this.setState({attribute: true});

                let size = '';
                if (obj.size < 0.1 * 1024) { //如果小于0.1KB转化成B
                    size = obj.size.toFixed(2) + "B";
                } else if (obj.size < 0.1 * 1024 * 1024) {//如果小于0.1MB转化成KB
                    size = (obj.size / 1024).toFixed(2) + "KB";
                } else if (obj.size < 0.1 * 1024 * 1024 * 1024) { //如果小于0.1GB转化成MB
                    size = (obj.size / (1024 * 1024)).toFixed(2) + "MB";
                } else { //其他转化成GB
                    size = (obj.size / (1024 * 1024 * 1024)).toFixed(2) + "GB";
                }
                let sizestr = size + "";
                let len = sizestr.indexOf("\.");
                let dec = sizestr.substr(len + 1, 2);
                if (dec === "00") {//当小数点后为00时 去掉小数部分
                    return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
                }
                this.state.attributeFiles.createTime = array[0].createTime.time;
                if (obj.fileType === 'img') {
                    this.state.attributeFiles.name = '图片'
                    this.state.attributeFiles.src = obj.path;
                } else if (obj.fileType === 'video') {
                    this.state.attributeFiles.name = '视频'
                    this.state.attributeFiles.src = obj.path + '/thumbnails/1'
                } else if (obj.fileType === 'audio') {
                    this.state.attributeFiles.name = '音频'
                    this.state.attributeFiles.src = '/cm-sites/pms/library/images/audio.png'
                } else {
                    this.state.attributeFiles.src = 'images/other.png'
                    this.state.attributeFiles.name = '其他文件'
                }

                this.state.attributeFiles.size = sizestr;
                window.loading.hide();
                this.setState({})
            }
        } else {
            message.info("请至少选择一个文件或文件夹!");
        }

    }

    //重命名弹框
    rename() {
        if (array.length) {
            this.setState({name: array[0].name, rename: true})

        } else {
            message.info("请至少选择一个文件或文件夹!");
        }
    }

    //重命名
    handleRenameOk = () => {
        //永远只是改第一个
        let id = array[0]._id;
        let fileType = array[0].fileType;
        let md5 = array[0].md5;
        if (fileType === 'file') {
            storageDirectoryRename(id, this.state.name, () => {
                this.setState({rename: false});
                array = [];
                this.getList()

            });
        } else {
            storageFileRename(md5, this.state.name, () => {
                array = [];
                this.getList();
                this.setState({rename: false});
            })
        }
    };

    //右击
    contentRightClick(e) {
        if (!this.state.blank) {
            this.state.dataSource.forEach((item, index) => {
                item.checked = false;
            });
            array = [];
            this.state.rightClickMenu.forEach((item, index) => {
                if (this.state.filecopy === true) {
                    this.state.rightClickMenu[5].color = 'black';
                } else {
                    this.state.rightClickMenu[5].color = 'grey';
                }
                this.state.rightClickMenu[0].color = 'grey';
                this.state.rightClickMenu[1].color = 'grey';
                this.state.rightClickMenu[2].color = 'black';
                this.state.rightClickMenu[3].color = 'grey';
                this.state.rightClickMenu[4].color = 'grey';
                this.state.rightClickMenu[6].color = 'grey';
            })
            this.state.right = false
        }
        if (array.length) {

            this.state.rightClickMenu.forEach((item, index) => {
                if (this.state.filecopy === true) {
                    this.state.rightClickMenu[5].color = 'black';
                } else {
                    this.state.rightClickMenu[5].color = 'grey';
                }
                this.state.rightClickMenu[0].color = 'black';
                this.state.rightClickMenu[1].color = 'black';
                this.state.rightClickMenu[2].color = 'black';
                this.state.rightClickMenu[3].color = 'black';
                this.state.rightClickMenu[4].color = 'black';
                this.state.rightClickMenu[6].color = 'black';

            })
            this.state.right = true
        }
        this.setState({})
        this.RightClickMenu.showMenu(e)
        //  this.singleClick(e)
    }
   //移除
    remove(){
        this.publish();
        let that = this;
        if(this.state.checkedId.allIds.length) {
            let fileIds = that.state.checkedId.fileIds;
            let md5= [];
            this.state.dataSource.forEach((item, index) => {
                fileIds.forEach((i, index) => {
                    if (i === item._id) {
                        md5.push(item.md5);
                    }
                })
            });
            confirm({
                title: '确定要将所选项移除?',
                onOk() {
                    removeFromDirecotry(that.state.resourceId, md5.join(","), () => {
                        that.getList()
                    });
                },
                onCancel() {
                    that.setState({confirmVisible: false});
                },
            });
        } else {
            message.error("请至少选择一个文件或文件夹!");
        }
    }

    //删除
    gotoRecycle() {
        this.publish();
        let that = this;
        if (this.state.checkedId.allIds.length) {
            let fileIds = that.state.checkedId.fileIds;
            let md5s = [];
            this.state.dataSource.forEach((item, index) => {
                fileIds.forEach((i, index) => {
                    if (i === item._id) {
                        md5s.push(item.md5);
                    }
                })
            });
            confirm({
                title: '确定要将所选项移至回收站?',
                onOk() {
                    let directoryIds = that.state.checkedId.directoryIds.toString().replace(/(.*),$/, '$1');
                    moveToRecycle(directoryIds, fileIds, md5s.join(","), () => {
                        that.getList()
                    });
                },
                onCancel() {
                    that.setState({confirmVisible: false});
                },
            });
        } else {
            message.error("请至少选择一个文件或文件夹!");
        }
    };

    //获取列表
    getList() {
        window.loading.show();
        Actions.getresourcesList(this.state.resourceId, (data) => {
            this.pubicList(data)
        })
    };

    //属性弹框的确定事件
    sureAttribute = () => {
        let id = array[0]._id;
        let type = array[0].fileType;
        let md5 = array[0].md5;
        if (type === 'file') {
            storageDirectoryRename(id, this.state.name, () => {
                this.setState({rename: false});
                this.getList()
            });
        } else {
            storageFileRename(md5, this.state.name, () => {
                array = [];
                this.getList();
                this.setState({rename: false});
            })
        }

        array = [];
        this.setState({attribute: false})
    };

    //双击点击事件
    handleDoubleClick(item) {
        window.loading.show();
        let path = item.path;
        let id = item._id;
        let fileType = item.fileType;
        if (fileType === 'img') {
            picFiles = this.state.imgList;
            let that = this;
            window.layui.config({
                base: '/cm-sites/layuiadmin/' //静态资源所在路径
            }).extend({
                index: 'lib/index' //主入口模块
            }).use(["index", "buttons"], function () {
                let buttons = window.layui.buttons;
                getByPath(path, (pic) => {
                    window.loading.hide();
                    //图片滚动预览
                    let pictureList = picFiles;
                    let index = 0;

                    let picPaths = [];
                    //获取当前图片在数组中的索引；
                    for (let i = 0; i < pictureList.length; i++) {
                        picPaths.push(pictureList[i].path);
                    }

                    //更具paths获取pictureinfos
                    let params = {paths: picPaths};
                    getPictureInfosByPath(params, function (pics) {
                        for (let i = 0; i < pics.length; i++) {
                            if (pics[i].path == pic.path) {
                                index = i;
                                break;
                            }
                        }
                        let viewPic = {
                            list: pics,
                            index: index
                        };
                        buttons.view(viewPic, 2, "图片详情", that.props.baseWidth, that.props.baseHeight, that.props.offsetX, that.props.offsetY);
                    })
                });
            })
        } else if (fileType === 'file') {
            Actions.getresourcesList(id, (data) => {
                this.pubicList(data)
            })

        } else if (fileType === 'video') {
            let that = this;
            window.layui.config({
                base: '/cm-sites/layuiadmin/' //静态资源所在路径
            }).extend({
                index: 'lib/index' //主入口模块
            }).use(["index", "buttons"], function () {
                let buttons = window.layui.buttons;
                getByPath(path, (video) => {
                    window.loading.hide();
                    if (video) {
                        buttons.view(video, 3, "视频详情", that.props.baseWidth, that.props.baseHeight, that.props.offsetX, that.props.offsetY);
                    } else {
                        message.error("该资源不在媒资库中，无法查看。");
                    }
                });
            })
        } else if (fileType === 'audio') {
            let that = this;
            window.layui.config({
                base: '/cm-sites/layuiadmin/' //静态资源所在路径
            }).extend({
                index: 'lib/index' //主入口模块
            }).use(["index", "buttons"], function () {
                let buttons = window.layui.buttons;
                getByPath(path, (audio) => {
                    window.loading.hide();
                    if (audio) {
                        buttons.view(audio, 5, "音频详情", that.props.baseWidth, that.props.baseHeight, that.props.offsetX, that.props.offsetY);
                    } else {
                        message.error("该资源不在媒资库中，无法查看。");
                    }
                });
            })
        } else if (fileType === 'other') {
            let that = this;
            window.layui.config({
                base: '/cm-sites/layuiadmin/' //静态资源所在路径
            }).extend({
                index: 'lib/index' //主入口模块
            }).use(["index", "buttons"], function () {
                let buttons = window.layui.buttons;
                window.loading.show();
                getByPath(path, (file) => {
                    window.loading.hide();
                    if (file) {
                        if (fileType === 'img') {

                            buttons.view(file, 2, "图片详情", that.props.baseWidth, that.props.baseHeight, that.props.offsetX, that.props.offsetY);
                        } else if (fileType === 'video') {

                            buttons.view(file, 3, "视频详情", that.props.baseWidth, that.props.baseHeight, that.props.offsetX, that.props.offsetY);
                        } else if (fileType === 'audio') {

                            buttons.view(file, 5, "音频详情", that.props.baseWidth, that.props.baseHeight, that.props.offsetX, that.props.offsetY);
                        } else {

                            buttons.view(file, 4, "文件详情", that.props.baseWidth, that.props.baseHeight, that.props.offsetX, that.props.offsetY);
                        }
                    } else {
                        message.error("该资源不在媒资库中，无法查看。");
                    }
                });
            })
        }
    };

    //获取列表的公共发放
    pubicList(data,sortType,sortCondition) {

        let dataSource = [];
        let fileListArray = data.directorys;
        let imgList = data.files;
        this.setState({fileListArray: fileListArray});
        this.setState({imgList: imgList});
        if (!fileListArray) {
            return;
        }
        fileListArray.map((item, index) => {
            item.fileType = 'file';
            fileListArray = [...fileListArray]
        });
        imgList.map((item, index) => {
            if (item.type === 2) {
                item.fileType = 'video';
                // item.path = item.path + '/thumbnails/1'
            } else if (item.type === 1) {
                item.fileType = 'img';
            } else if (item.type === 4) {
                item.fileType = 'audio';
            } else if (item.type === 3) {
                item.fileType = 'other';
            }
            imgList = [...imgList]
        });
        if(sortType=== -1 && sortCondition === 'type') {
            dataSource = imgList.concat(fileListArray);
        }else {
            dataSource = fileListArray.concat(imgList);
        }
        this.state.AllData= JSON.parse(JSON.stringify(dataSource));

        this.setState({});

        this.paging(dataSource)


    };
    paging(dataSource){
        let start = ((parseInt(this.state.start)-1)*this.state.pageSize+1)
        let end = ((parseInt(this.state.start)-1)*this.state.pageSize+this.state.pageSize)
        let currentSliceDataSourceArr = this.state.AllData.slice(start,end);
        if(this.state.start===1){
            dataSource=currentSliceDataSourceArr
        }else{
            dataSource=[...this.state.dataSource,...currentSliceDataSourceArr]
        }
        this.setState({dataSource: dataSource},()=>{
            window.loading.hide();
        })
    }
    publish() {
        this.state.checkedId.directoryIds = [];
        this.state.checkedId.fileIds = [];
        this.state.checkedId.allIds = [];
        this.state.downloadFile =[];
        // this.state.fileListArray.forEach((item, index) => {
        //     if (item.checked === true) {
        //         this.state.checkedId.directoryIds.push(item._id)
        //     }
        // });
        // this.state.imgList.forEach((item, index) => {
        //      if(item.checked===true){
        //          this.state.checkedId.fileIds.push(item._id)
        //      }
        // });
        this.state.dataSource.forEach((item, index) => {
            if (item.checked === true) {
                if(item.fileType ==='file'){
                    this.state.checkedId.directoryIds.push(item._id)
                }else{
                    this.state.checkedId.fileIds.push(item._id)
                    this.state.downloadFile.push(item)
                }
                this.state.checkedId.allIds.push(item._id)
            }
        });
        this.setState({})
    }
    /*监听滚动*/
    onScroll = e => {
        let count = Math.ceil(this.state.AllData.length/this.state.pageSize)

        if (e.target.scrollTop + e.target.clientHeight === e.target.scrollHeight) {
         if(this.state.start<count){
             this.state.start = this.state.start + 1;
             this.paging( this.state.AllData)
         }
        }
    };

    //下载
    gotoBatchDownload = () => {
        this.setState({folder:true})
        this.publish();
        let download_number = window.top.sysConfig.getConfigByKey("pms.resources.download.number").configValue;
        let that = this;

        if (this.state.checkedId.fileIds.length>download_number) {

            let directoryIds = this.state.checkedId.directoryIds.toString().replace(/(.*),$/, '$1');
            let fileIds = this.state.checkedId.fileIds.toString().replace(/(.*),$/, '$1');
            let params = {
                directoryIds: directoryIds,
                fileIds: fileIds
            };
            getBatchDownloadPath(params, function (data) {
                if (data.code === 2) {
                    // message.success("请到我的下载，去下载文件");
                    Modal.confirm({
                        title: '已成功添加下载队列',
                        content: '请前往“我的下载”页面查看下载',
                        okText: "确定前往",
                        cancelText: '关闭',
                        icon: <Icon type="check-circle"/>,
                        onOk() {
                            that.state.history.push("/library/download/downloadList");
                        },
                        onCancel() {
                        }
                    });
                }
            })
        }else if(this.state.checkedId.fileIds.length&&this.state.checkedId.fileIds.length <=download_number) {
            this.state.downloadFile.forEach((item,index)=>{
                if(item.fileType !== "file"){
                    let path=item.path;
                    if(path.indexOf('?')>-1){
                        path=path+'&download=1'
                    }else {
                        path=path+'?download=1'
                    }
                    window.open(`${path}` ,'_blank')
                }else{
                    if (this.state.folder) {
                        message.info('文件夹不可以下载')
                        this.state.folder = false
                    } else {
                        this.state.folder = false
                    }


                }

            })
        }else if(!this.state.checkedId.allIds.length){
            message.error("请至少选择一个文件或文件夹!");
        }
    };

    // 上传文件
    showOnlyFileUploadDialog() {
        this.SetUp.show();
        this.setState({warehousing: true, fileList: []})
    }

    //点击工具箱
    holdAll(id) {
        if (id === '1') {
            this.publish();
            if (this.state.checkedId.allIds.length) {
                let directoryIds = this.state.checkedId.directoryIds.toString().replace(/(.*),$/, '$1');
                let fileIds = this.state.checkedId.fileIds;
                let md5s = [];
                this.state.dataSource.forEach((item, index) => {
                    fileIds.forEach((i, index) => {
                        if (i === item._id) {
                            md5s.push(item.md5);
                        }
                    })
                });
                window.layer.open({
                    title: '批量添加标签',
                    type: 2,
                    shade: 0.8,
                    content: '/cm-sites/' + applicationName() + '/library/upload/writeLabel.html',
                    area: ["800px", "200px"],
                    btn: ['保存', '关闭'],
                    cancel: function (index, layero) {
                        window.layer.close(index);
                    },
                    end: function (index, layero) {
                    },
                    yes: function (index, layero) {
                        let openPage = window[layero.find('iframe')[0]['name']];
                        if (openPage.labelNames !== "") {
                            let loadIndex = window.layer.load();
                            addLabel(directoryIds, md5s.join(","), openPage.labelNames, () => {
                                window.layer.close(loadIndex);
                            });
                        }
                        window.layer.close(index);
                    }
                });
            } else {
                message.error("请至少选择一个文件或文件夹!");
            }

        } else if (id === '2') {
            this.publish();
            let that = this;
            if (this.state.checkedId.allIds.length) {
                let url = '/cm-sites/pms/library/showDept.html?';
                window.layer.open({
                    title: '设置相关部门',
                    type: 2,
                    content: url,
                    area: ['411px', '570px'],
                    resize: false,
                    shade: 0.001,	//遮罩
                    btn: ['保存', '取消'],
                    yes: function (index, layero) {
                        let openPage = window[layero.find('iframe')[0]['name']];
                        let node = openPage.getCheckedNodes();
                        let nodeResult = "";
                        let newRelatedDeptIds = [];
                        if (node.length > 0) {
                            for (let j = 0; j < node.length; j++) {
                                if (j === 0)
                                    nodeResult = node[j].id;
                                else
                                    nodeResult = nodeResult + ',' + node[j].id;
                                newRelatedDeptIds[j] = node[j].id;
                            }
                        }

                        let fileIds = that.state.checkedId.fileIds;
                        let md5s = [];
                        that.state.dataSource.forEach((item, index) => {
                            fileIds.forEach((i, index) => {
                                if (i === item._id) {
                                    md5s.push(item.md5);
                                }
                            })
                        });

                        let directoryIds = that.state.checkedId.directoryIds.toString().replace(/(.*),$/, '$1');

                        let loadIndex = window.layer.load(2);
                        addRelatedDeptIds(md5s.join(), directoryIds, newRelatedDeptIds.join(), () => {
                            window.layer.close(loadIndex);
                            window.layer.close(index);
                        })
                    }, btn2: function (index, layero) {//取消按钮
                    }
                });
            } else {
                message.error("请至少选择一个文件或文件夹!");
            }

        } else if (id === '3') {
            window.layer.open({
                title: '图片多功能搜索引擎',
                type: 2,
                shade: 0.8,
                content: '/cm-sites/' + applicationName() + '/library/picture/pictureList.html',
                area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px'],
                resize: false,
            });
        } else if (id === '4') {
            window.layer.open({
                title: '视频多功能搜索引擎',
                type: 2,
                shade: 0.8,
                content: '/cm-sites/' + applicationName() + '/library/video/videoList.html',
                area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px'],
                resize: false,
            });
        } else if (id === '5') {
            window.layer.open({
                title: '音频多功能搜索引擎',
                type: 2,
                shade: 0.8,
                content: '/cm-sites/' + applicationName() + '/library/audio/audioList.html',
                area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px'],
                resize: false,
            });
        } else if (id === '6') {
            window.layer.open({
                title: '文件多功能搜索引擎',
                type: 2,
                shade: 0.8,
                content: '/cm-sites/' + applicationName() + '/library/file/fileList.html',
                area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px'],
                resize: false,
            });
        }
    }

    //搜索
    search = e => {
        search(e, this.state.resourceId, (data) => {
            this.pubicList(data)
        });
    };
    //显示工具箱的弹框
    showModalHoldAll = () => {
        this.setState({holdAll: true});
    };
    //显示设置分类的弹框
    showModalSetting = () => {
        //this.setState({setting: true});
        this.HoldAll.show();
        this.setState({showProcess: false})
    };

    //创建文件夹
    createStorageDirectory = () => {
        let prevState = Object.assign({}, this.state);
        let name = "新建文件夹";
        if (prevState.fileListArray.length > 0) {
            let allIndex = "";
            let maxIndex = prevState.fileListArray.length;
            for (let i = 1; i < maxIndex + 1; i++) {
                allIndex += i + ",";
            }
            let oldAllIndex = allIndex;
            prevState.fileListArray.map((item, index) => {
                if (item.name === "新建文件夹") {
                    allIndex = allIndex.replace("1,", "");
                } else {
                    let resultIndex = item.name.replace(/^新建文件夹（(\d+)）$/, "$1");
                    if (!isNaN(parseInt(resultIndex))) {
                        allIndex = allIndex.replace(parseInt(resultIndex) + ",", "");
                    }
                }
            });

            if (allIndex === oldAllIndex) {
                name = "新建文件夹";
            } else if (allIndex === "") {
                name = "新建文件夹（" + (prevState.fileListArray.length + 1) + "）";
            } else {
                name = "新建文件夹（" + allIndex.replace(/^(\d+),.*/, "$1") + "）";
            }
            if (name === "新建文件夹（1）") {
                name = "新建文件夹";
            }
        }

        let url = "/cm-sites-" + applicationName() + "/storage/createStorageDirectory";
        let fid = this.state.resourceId;
        this.request({url, method:"post", body:{name, fid}, callBack:()=>{
            this.getList()
        }});
    };

    upDataCheckedId() {
        let checkAll = [];
        this.state.dataSource.map((item, index) => {
            if (item.checked === true) {
                checkAll.push(item._id)
            }

        })
    }

    //关闭工具箱的弹框
    handleCancel = e => {
        this.setState({holdAll: false, setting: false, share: false, attribute: false, warehousing: false});

        // this.upDataCheckedId()
    };
    //切换单选  全选  反选 多选
    onChangeRadio = e => {
        if (e.target.value === 3) {
            this.allCheck()
        } else if (e.target.value === 4) {
            this.antiElection()
        }
        this.setState({value: e.target.value})

    };
    //切换大图标小图标中图标以及list
    onChangeType = e => {
        this.setState({type: e.target.value});
    };

    //单击
    singleClick(index, item) {

        if (this.state.value === 1) {
            this.oneCheck(index, item)
        } else if (this.state.value === 2) {
            this.moreCheck(index, item)
        } else if (this.state.value === 3 || this.state.value === 4) {
            this.state.value = 1;
            this.oneCheck(index, item)
        }
        this.setState({blank: false})
    }

    //push array 数组
    recombination(data) {
        if (data.checked === true) {
            array.push(data)
        } else {
            let newArray = [];
            array.forEach((item, index) => {
                if (item.checked === true) {

                    newArray.push(item);
                    array = newArray;
                }
            });

        }
    }

    //单选，
    oneCheck(index, item) {
        array = [];
        let currentStatus = item.checked;
        this.state.dataSource.forEach(i => {
            i.checked = false;
        });
        this.state.dataSource[index].checked = !currentStatus;
        this.recombination(item);
        this.setState({});
        this.upDataCheckedId()
    }

    //多选
    moreCheck(index, item) {
        let num = 0;
        this.state.dataSource[index].checked = !item.checked;
        this.state.dataSource.forEach(i => {
            if (i.checked === true) {
                num++
            }
        });
        if (num === this.state.dataSource.length) {
            this.state.value = 3;
        }
        this.recombination(item);
        this.setState({});
        this.upDataCheckedId()
    }

    //全选
    allCheck() {
        this.state.dataSource.forEach(i => {
            i.checked = true;
            this.recombination(i)
        });
        this.setState({});
        this.upDataCheckedId()
    }

    //反选
    antiElection() {
        this.state.dataSource.forEach(i => {
            i.checked = !i.checked;
            this.recombination(i)
        });

        this.setState({});
        this.upDataCheckedId()
    }
}